<template>
  <div class="modal-wrapper" @click.self="close">
    <div class="modal-block">
      <button class="close-btn" @click="close">✖</button>

      <div class="content">
        <h4>{{ pointSignType == "signed" ? "Подписанные заказы" : "Неподписанные заказы" }}</h4>
        <table class="points-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Название / Аптека</th>
              <th>Финальный номер</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(point, index) in filteredPoints" :key="point.id">
              <td>{{ index + 1 }}</td>

              <td>{{ point.point_type == 1 ? point.name : point.pharmacy_number }}</td>

              <td>{{ point.point_type == 1 ? "" : point.final_name }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    points: {
      type: Array,
      default: () => [],
    },
    pointSignType: {
      type: String,
      default: () => "unsigned",
    },
  },
  emits: ["close"],
  computed: {
    filteredPoints() {
      return this.pointSignType === "signed"
        ? this.points.filter((p) => p.status_sign == 1)
        : this.points.filter((p) => p.status_sign == 0);
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
}

.modal-block {
  position: relative;
  width: 40%;
  height: 40%;
  background: white;
  border: 1px solid lightcyan;
  border-radius: 10px;
  padding: 20px;
}

.content {
  max-height: calc(100% - 40px);
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;

  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

.close-btn:hover {
  background: lightblue;
}

.points-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.points-table th,
.points-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.points-table th {
  background: #f7f7f7;
  font-weight: bold;
}

.points-table tr:nth-child(even) {
  background: #fafafa;
}
</style>
